<nf-grid-wrapper>
  <ng-grid-wrapper-header-right>
    <nf-checkbox
      class="small mr-2"
      [formControl]="hideFutureAccrualsToggle"
      label="Hide Future Accruals"
    ></nf-checkbox>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      #table
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [data]="data"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
      hideTitle
    >
      <ng-content></ng-content>
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
